import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import PopularTags from './PopularTags'
import Connect from './Connect'
import FeaturedStories from './FeaturedStories'

const styles = (theme) => ({
  root: {
    color: theme.palette.primary.dark,
  },
  linkText: {
    fontFamily: 'Roboto',
    fontSize: '0.9em',
  },
  latestPostsHeader: {
    color: theme.palette.primary.main,
  },
  readMoreLink: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    fontSize: '0.9em',
  },
})

const Sidebar = ({ classes, theme, posts, tags, featuredStories }) => {
  return (
    <div className={classes.root}>
      {/* <LatestPosts
        header="Latest Posts"
        posts={posts}
        controller={controller}
        thumbResolutions={thumbResolutions}
      /> */}
      <Connect header="Connect" />
      {tags && <PopularTags header="Hot Tags" tags={tags} />}
      <FeaturedStories header="Featured Stories" stories={featuredStories} />
      {/* <Section render={() => <BannerAd size="300x250" adNumber={1} />} />
      <Section render={() => <BannerAd size="300x250" adNumber={2} />} /> */}
      <style>{`
        a {
          color: ${theme.palette.primary.main};
        }
      `}</style>
    </div>
  )
}

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  posts: PropTypes.array,
  tags: PropTypes.array,
  featuredStories: PropTypes.object,
  thumbResolutions: PropTypes.object,
}

// prettier-ignore
export default compose(
  withStyles(styles, { withTheme: true }),
)(Sidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js